import { array, number, object } from 'yup'
import { isAfter, isToday } from "date-fns"

import { rentalDates, rentalLength } from "@signals"


export const realTimeSchema = object({
	officePickupID: number().required('Office Pickup is required')
		.transform((value, original) => (original === "" ? null : value)),
	siteID: array().required('Site is required').min(1, 'Site is required'),
	rentalLength: array().required('Length of Rental is required').min(1, 'Rental length is required')
		.test(
			'limit',
			'Combinations for more than 10 searches from rental dates and rental lengths not allowed',
			() => (rentalLength.value.length * rentalDates.value.length) <= 10),
	rentalDates: array().required('Rental date is required').min(1, 'Rental date is required')
		.test(
			'limit',
			'Combinations for more than 10 searches from rental dates and rental lengths not allowed',
			() => (rentalLength.value.length * rentalDates.value.length) <= 10)
		.test('before', 'Cant set dates before today', () => rentalDates.value.every(d => isAfter(d, new Date()) || isToday(d)))
})